import { User, Mail, Globe, Instagram } from 'lucide-react';

const StepInstructorInfo = ({ formData, handleInputChange }) => {
  return (
    <div className="space-y-6">
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
        <p className="text-sm text-blue-800">
          <strong>Optional:</strong> Add information about instructors or guides who will be leading the experience.
        </p>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
          <User className="w-4 h-4 text-emerald-600" />
          Instructor/Guide Name
        </label>
        <input
          type="text"
          className="w-full px-4 py-3 border border-gray-200 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition-all duration-200 bg-white/50"
          placeholder="John Doe"
          value={formData.instructorName || ''}
          onChange={(e) => handleInputChange('instructorName', e.target.value)}
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Bio/Background
        </label>
        <textarea
          rows={4}
          className="w-full px-4 py-3 border border-gray-200 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition-all duration-200 bg-white/50 resize-none"
          placeholder="Tell guests about the instructor's background, certifications, experience..."
          value={formData.instructorBio || ''}
          onChange={(e) => handleInputChange('instructorBio', e.target.value)}
        />
        <p className="mt-1 text-xs text-gray-500">
          {(formData.instructorBio || '').length.toLocaleString()} characters
        </p>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
          <Mail className="w-4 h-4 text-emerald-600" />
          Email
        </label>
        <input
          type="email"
          className="w-full px-4 py-3 border border-gray-200 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition-all duration-200 bg-white/50"
          placeholder="instructor@example.com"
          value={formData.instructorEmail || ''}
          onChange={(e) => handleInputChange('instructorEmail', e.target.value)}
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
          <Globe className="w-4 h-4 text-emerald-600" />
          Website
        </label>
        <input
          type="url"
          className="w-full px-4 py-3 border border-gray-200 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition-all duration-200 bg-white/50"
          placeholder="https://instructor-website.com"
          value={formData.instructorWebsite || ''}
          onChange={(e) => handleInputChange('instructorWebsite', e.target.value)}
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
          <Instagram className="w-4 h-4 text-emerald-600" />
          Instagram Handle
        </label>
        <input
          type="text"
          className="w-full px-4 py-3 border border-gray-200 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition-all duration-200 bg-white/50"
          placeholder="@instructorhandle"
          value={formData.instructorInstagram || ''}
          onChange={(e) => handleInputChange('instructorInstagram', e.target.value)}
        />
      </div>
    </div>
  );
};

export default StepInstructorInfo;

